/**
 * Multihub Logo (monochrome white)
 *
 * Full wordmark for dark backgrounds.
 */

import type { ImageLogoProps } from '../types';

import multihubLogoMonoWhiteUrl from './multihub-logo-mono-white.svg';

const ASPECT_RATIO = 1473.49 / 217.42;

export function MultihubLogoMonoWhite({
  height = 32,
  width,
  alt = 'Multihub',
  ...props
}: ImageLogoProps) {
  const computedWidth =
    width ?? (typeof height === 'number' ? height * ASPECT_RATIO : undefined);

  return (
    <img
      src={multihubLogoMonoWhiteUrl}
      alt={alt}
      height={height}
      width={computedWidth}
      {...props}
    />
  );
}
